<template>
  <div class="accordion-objective">
    <span class="quarter-header text-muted">Quarter {{ formattedLevel }}</span>
    <h3 class="objective-title">{{ title }}</h3>
    <slot/>
  </div>
</template>

<script>
import CopyTextWrapper from '@/components/CopyTrackWrapper'

export default {
  name: 'AccordionObjective',
  components: { CopyTextWrapper },
  props: {
    level: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Measurable Objective'
    },
    text: {
      type: String,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedLevel() {
      switch (this.level) {
        case '1st':
          return '1'
        case '2nd':
          return '2'
        case '3rd':
          return 3
        default:
          return this.level
      }
    }
  }
}
</script>

<style lang="less" scoped>
.accordion-objective{
    margin-bottom: 15px;
    width: fit-content;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: #333;
    font-weight: 300;
    width: 100%;
    font-size: 18px;
    line-height: 1.6;
}
/deep/ .pl-textarea{
  width: 100%;
  font-size: 18px;
}
.quarter-header{
    font-size: 11px;
    text-transform: uppercase;
    margin-top: 35px;
    margin-bottom: 9px;
    font-weight: 500;
    color: #6f6f6f;
}
.objective-title {
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 10px;
    color: #333;
}
.objective-text {
    margin-top: 11px;
    margin-bottom: 35px;
}
.wiki-text-container p {
  color: #333;
}
</style>